
// import UserInfoBox from "@/components/UserInfoBox";
// import recoveryCenter from "@/components/recoveryCenter/index";
export default {
    components: {
        // UserInfoBox,
        // recoveryCenter
    },
    data() {
        return {}
    },
    mounted() {},
    methods: {}
}
